<template>
    <div class="all-trainers">
        <div class="module module--space-default">
            <template v-if="trainers !== null">
                <div class="all-trainers__top">
                    <div class="container container--nooverflow">
                        <h1 class="all-trainers__title">
                            <translate>trainer</translate>
                            <span class="up-text text text--large">{{trainers.length}}</span>
                        </h1>
                    </div>
                </div>
                <div class="container">
                    <div class="all-trainers__list">
                        <div class="all-trainers__trainer" v-for="trainer in trainers" :key="trainer.id">
                            <router-link :to="{name: 'Trainer', params: {id: trainer.id}}">
                                <TrainerIcon :trainer="trainer"></TrainerIcon>
                            </router-link>
                        </div>
                    </div>
                </div>
            </template>
            <div class="all-trainers__loader" v-else>
                <Loader></Loader>
            </div>
        </div>
    </div>
</template>

<script>
import TrainerIcon from '@/components/TrainerIcon';
import { mapGetters } from 'vuex'

import {addTrackingObject} from "@/utils/tracking"

export default {
    components: {
        TrainerIcon
    },
    computed: {
        ...mapGetters(['trainers']),
    },
    mounted() {
        addTrackingObject({subSection: "home", screenName: "allTrainers"}, {type: "trainer", value: "web_all_trainer_page"});
    }
}
</script>

<style scoped lang="scss">
.all-trainers {
    $block: &;

    &__top {
        padding: 0 0 20px;
        margin: -20px 0 40px;
        border-bottom: 1px solid rgba(black, 0.1);
    }

    &__loader {
        display: flex;
        justify-content: center;
    }

    &__list {
        display: flex;
        flex-wrap: wrap;
        margin: 0 -5px;

        @include mq(mobile-landscape) {
            margin: 0 -10px;
        }

        @include mq(tablet) {
            margin: 0 -16px;
        }
    }

    &__trainer {
        width: calc(50% - 10px);
        margin: 0 5px;
        padding-bottom: 40px;

        @include mq(mobile-landscape) {
            width: calc(33.3333% - 20px);
            margin: 0 10px;
        }

        @include mq(tablet) {
            width: calc(25% - 32px);
            margin: 0 16px;
        }

        @include mq(tablet-landscape) {
            width: calc(20% - 32px);
        }

        @include mq(desktop) {
            width: calc((1 * 100% / 7) - 32px);
        }
    }
}
</style>